export type NotificationsState = Array<SnackbarNotification>;
type State = { notifications: NotificationsState };

export const notificationsSelector = (state: State) => state.notifications;
